export const jackpotBetWidgetWatcher = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        WATCH_JACKPOT_BET_FEEDS: {
          target: 'watchJackpotBetFeeds',
        },
      },
    },
    watchJackpotBetFeeds: {
      invoke: [{ src: 'watchJackpotBetFeeds' }],
      on: {
        UPDATE_JACKPOT_BET_FEEDS: {
          target:
            '#root.main.jackpotBetWidgetController.fetchJackpotBetFeedsByLiquidity',
        },
      },
    },
  },
};
